import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';

import { Driver, Table } from 'services/action';
import { Select, Form } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

const initialState = {
  isLoading: true,
  name: '',
  phone: '',
  vehicle_number: '',
  bank_account: '',
  vendor: '',
};

export const FormInput = ({ data, onClose }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state.Form);
  const StateTable = useSelector((state) => state?.Table?.data['driver']);

  const dummy = Array.from({ length: 5 }, (v, i) => i);

  const [
    { name, phone, vehicle_number, bank_account, vendor, isLoading },
    setState,
  ] = React.useState(initialState);

  const $handleSubmit = async (c) => {
    const payload = {
      name,
      phone,
      vehicle_number,
      bank_account,
      vendor_id: vendor?.id,
    };

    if (data) {
      const submit = await Dispatch(Driver.$update(data?.id, payload));
      if (submit?.message === 'success') {
        onClose();
        Dispatch(Table.$reload('driver', StateTable));
      }
    } else {
      const submit = await Dispatch(Driver.$create(payload));
      if (submit?.message === 'success') {
        onClose();
        Dispatch(Table.$reload('driver', StateTable));
      }
    }
  };

  React.useEffect(() => {
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }, 2000);
  }, []);

  React.useEffect(() => {
    if (!data) return;

    setState((prevState) => ({
      ...prevState,
      name: data?.name,
      phone: data?.phone,
      vehicle_number: data?.vehicle_number,
      bank_account: data?.bank_account,
      vendor: data?.vendor,
    }));
  }, [data]);

  if (isLoading) {
    return (
      <Modal.Body>
        <div className="row m-0">
          {dummy?.map((d, i) => (
            <div className="col-md-6 col-12" key={i}>
              <SkeletonsForm count={1} />
            </div>
          ))}
        </div>
      </Modal.Body>
    );
  }

  return (
    <div>
      <Modal.Body>
        <div className="row ">
          <div className="col-12 col-md-6">
            <Select.Remote
              label="Pilih Vendor"
              placeholder=""
              url="/partner"
              params={{'type': 'vendor'}}
              value={vendor}
              initialValue={vendor?.id}
              row={(d) => {
                return {
                  value: d.id,
                  label: d.name,
                };
              }}
              onSelected={(c) => {
                setState((prevState) => ({
                  ...prevState,
                  vendor: c,
                }));
              }}
              errors={StateForm?.errors?.vendor_id}
            />
          </div>
          <div className="col-12 col-md-6">
            <div className="form-group mb-3 ">
              <Form.Input
                required
                label="Nama Driver"
                type="text"
                value={name}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    name: e.target.value,
                  }))
                }
                error={StateForm?.errors?.name}
              />
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="form-group mb-3 ">
              <Form.Input
                required
                label="No. Handphone"
                type="phone"
                value={phone}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    phone: e.target.value,
                  }))
                }
                error={StateForm?.errors?.phone}
              />
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="form-group mb-3 ">
              <Form.Input
                required
                label="No. Polisi Kendaraan"
                type="text"
                value={vehicle_number}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    vehicle_number: e.target.value,
                  }))
                }
                error={StateForm?.errors?.vehicle_number}
              />
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="form-group mb-3 ">
              <Form.Input
                label="Nama Bank &amp; No. Rekening"
                type="text"
                value={bank_account}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    bank_account: e.target.value,
                  }))
                }
                error={StateForm?.errors?.bank_account}
              />
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className="d-flex justify-content-end">
          <Button
            type="button"
            className={cn(
              StateForm?.loading ? 'btn-loading' : '',
              'btn btn-primary px-3 py-2'
            )}
            disabled={StateForm?.loading}
            onClick={$handleSubmit}
          >
            Simpan
          </Button>
        </div>
      </Modal.Footer>
    </div>
  );
};
